import { render, staticRenderFns } from "./VerifiedAddModal.vue?vue&type=template&id=9b8da800&scoped=true&"
import script from "./VerifiedAddModal.vue?vue&type=script&lang=js&"
export * from "./VerifiedAddModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedAddModal.vue?vue&type=style&index=0&id=9b8da800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8da800",
  null
  
)

export default component.exports